module.exports = __webpack_public_path__ + "static/thales-marketing-67a51f64996669fa224bd523776dd19d.jpg";